// extracted by mini-css-extract-plugin
export default {"settings-section":"styles_settings-section__NcYT4","plausible-link":"styles_plausible-link__lDXFC","plausible-logo":"styles_plausible-logo__HIGs5"};